export function GoogleSignInButton({ label = "Continue with Google" }) {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div>
      <div className="flex items-center gap-3 my-4 text-[10px] font-mono uppercase text-[#5A6B5D]">
        <span className="flex-1 h-px bg-[#E2DDD5]" />or<span className="flex-1 h-px bg-[#E2DDD5]" />
      </div>
      <button type="button" onClick={go} data-testid="google-signin-button"
        className="w-full flex items-center justify-center gap-3 border border-[#E2DDD5] bg-white rounded-full py-2.5 text-sm font-semibold text-[#1A201C] hover:bg-[#FAF8F5] transition-colors">
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.5 13.3l7.9 6.1C12.3 13.6 17.7 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.6 5.9c4.5-4.1 7-10.2 7-17.6z"/>
          <path fill="#FBBC05" d="M10.4 28.6A14.6 14.6 0 0 1 9.5 24c0-1.6.3-3.2.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.5 10.7l7.9-6.1z"/>
          <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.8l-7.6-5.9c-2.1 1.4-4.8 2.3-8 2.3-6.3 0-11.7-4.1-13.6-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/>
        </svg>
        {label}
      </button>
    </div>
  );
}
